export enum PageType {
    WELCOME,
    EMAIL,
    DESTINATION,
    REDEEMED
}
